import {useEffect, useRef, useState} from 'react'
import styled, {css} from 'styled-components'
import {IOption} from '../../modules/core'

const Container = styled.div`
  position: relative;
`
const ListContainer = styled.div<{isOpen: boolean; width: number; height: number}>`
  cursor: pointer;
  margin-top: 5px;
  width: 100%;
  height: auto;
  position: absolute;
  border: 1px solid #5ac8fa;
  border-radius: 10px;
  padding: 2px;
  background-color: #fff;
  z-index: 999;

  ${(props) =>
    !props.isOpen &&
    css`
      display: none;
    `}
`

const ListItemContainer = styled.ul`
  display: inline-block;
  padding: 0;
  margin: 0;
  box-sizing: border-box;
  width: 100%;
  z-index: 999;
`

const ListItem = styled.li`
  list-style: none;
  white-space: nowrap;
  padding: 0.75rem 1rem;
  border-radius: 10px;
  &:hover {
    background: #ccccff;
  }
`

type Props = {
  name?: string
  value?: any
  className?: string
  options: IOption[]
  minLength?: number
  placeholder?: string
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void | undefined
  onSelect?: (optIndex: IOption) => void
  defaultValue?: string
  disabled?: boolean
} & typeof defaultProps

const defaultProps = {
  minLength: 3,
}

export const AutoComplete = (props: Props) => {
  const containerRef = useRef(null)
  const listRef = useRef<HTMLDivElement>(null)
  const txtRef = useRef<HTMLInputElement>(null)
  const [isOpen, setIsOpen] = useState(false)
  const [containerSize, setContainerSize] = useState({width: 0, height: 0})
  const [selectedOption, setSelectedOption] = useState(0)

  const toggling = (event: React.MouseEvent<HTMLDivElement>) => {
    setIsOpen(true)
    event.stopPropagation()
  }

  useEffect(() => {
    setContainerSize({
      width: listRef?.current ? listRef.current.offsetWidth : 0, // Consider border
      height: listRef?.current ? listRef.current.offsetHeight : 0,
    })

    const handleClickOutside = () => {
      setIsOpen(false)
    }

    document.addEventListener('click', handleClickOutside)
    return () => {
      document.removeEventListener('click', handleClickOutside)
    }
  }, [])

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.value.length >= props.minLength) props.onChange?.(e)
    setIsOpen(true)
    e.stopPropagation()
  }

  const handleSelectOpt = (selectedIndex: number) => {
    setSelectedOption(selectedIndex)
    setIsOpen(false)

    if (props.onSelect) {
      props.onSelect(props.options[selectedIndex])
    }
    if (txtRef.current) txtRef.current.value = props.options[selectedIndex].label
  }

  return (
    <>
      <Container ref={containerRef}>
        <input
          name={props.name}
          type='text'
          className={props.className}
          defaultValue={props.defaultValue}
          placeholder={props.placeholder}
          disabled={props.disabled}
          ref={txtRef}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleChange(e)}
          onClick={(e: React.MouseEvent<HTMLDivElement>) => toggling(e)}
        />

        <ListContainer isOpen={isOpen} ref={listRef} {...containerSize}>
          <ListItemContainer>
            {props.options && props.options.length > 0 ? (
              props.options.map((opt, index) => {
                return (
                  <ListItem key={index} onClick={() => handleSelectOpt(index)}>
                    {opt.label}
                  </ListItem>
                )
              })
            ) : (
              <ListItem>Not found</ListItem>
            )}
          </ListItemContainer>
        </ListContainer>
      </Container>
    </>
  )
}
AutoComplete.defaultProps = defaultProps
